import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { HerracContext } from "../../App";

function SparePartsForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  
  const { vehicleTypeData } = useContext(HerracContext);

  // Debug logging
  useEffect(() => {
    console.log('🔧 SparePartsForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  // Markaları yüklə
  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for spare parts...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data);
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  // Modelləri yüklə
  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data);
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: value,
    });
  };

  const handleBooleanChange = (e) => {
    const { name, value } = e.target;
    const boolValue = value === "true";
    
    console.log(`✅ Boolean field changed: ${name} = ${boolValue}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: boolValue
    });
  };

  return (
    <div className="sparePartsForm">
      {/* Marka */}
      <div>
        <h3>
          Avtomobil Markası <span>*</span>
          <span className="tooltip-icon" title="Hissənin uyğun olduğu marka">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={handleBrandChange} 
          disabled={filteredBrands.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      {/* Model */}
      <div>
        <h3>
          Avtomobil Modeli <span>*</span>
          <span className="tooltip-icon" title="Hissənin uyğun olduğu model">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange} 
          disabled={filteredModels.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      {/* Hissə növü */}
      <div>
        <h3>
          Hissə növü <span>*</span>
          <span className="tooltip-icon" title="Ehtiyat hissənin tipi">ℹ️</span>
        </h3>
        <select name="partType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <optgroup label="Mühərrik hissələri">
            <option value="Mühərrik">Mühərrik (komplekt)</option>
            <option value="Piston">Piston</option>
            <option value="Silindr">Silindr</option>
            <option value="Qaz paylaması">Qaz paylaması</option>
            <option value="Turbo">Turbo</option>
          </optgroup>
          <optgroup label="Transmissiya">
            <option value="Sürət qutusu">Sürət qutusu</option>
            <option value="Debriyaj">Debriyaj</option>
            <option value="Val">Val</option>
          </optgroup>
          <optgroup label="Asma sistemi">
            <option value="Amortizator">Amortizator</option>
            <option value="Yay">Yay</option>
            <option value="Qol">Qol</option>
          </optgroup>
          <optgroup label="Əyləc sistemi">
            <option value="Əyləc diski">Əyləc diski</option>
            <option value="Əyləc klocası">Əyləc klocası</option>
            <option value="Əyləc silindiri">Əyləc silindiri</option>
          </optgroup>
          <optgroup label="Kuzov hissələri">
            <option value="Qanad">Qanad</option>
            <option value="Bamper">Bamper</option>
            <option value="Qapı">Qapı</option>
            <option value="Kaput">Kaput</option>
            <option value="Baqaj qapağı">Baqaj qapağı</option>
            <option value="Optika">Far / Stop</option>
          </optgroup>
          <optgroup label="Daxili hissələr">
            <option value="Rul">Rul</option>
            <option value="Oturacaq">Oturacaq</option>
            <option value="Torpedo">Torpedo</option>
          </optgroup>
          <optgroup label="Elektrik">
            <option value="Akkumulyator">Akkumulyator</option>
            <option value="Generator">Generator</option>
            <option value="Starter">Starter</option>
          </optgroup>
          <optgroup label="Digər">
            <option value="Təkər">Təkər / Disk</option>
            <option value="Digər">Digər</option>
          </optgroup>
        </select>
      </div>

      {/* İstehsal ili */}
      <div>
        <h3>
          Uyğun gəldiyi illər <span>*</span>
          <span className="tooltip-icon" title="Hissənin uyğun olduğu avtomobil istehsal illəri">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="compatibleYears" 
          onChange={handleChange}
          placeholder="2015-2020"
          required
        />
      </div>

      {/* Hissə vəziyyəti */}
      <div>
        <h3>
          Vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Hissənin fiziki vəziyyəti">ℹ️</span>
        </h3>
        <select name="condition" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yeni">Yeni (istifadə olunmayıb)</option>
          <option value="İşlənmiş">İşlənmiş (yaxşı vəziyyətdə)</option>
          <option value="Təmirli">Təmir edilmiş</option>
          <option value="Orjinal">Orjinal (zavod)</option>
          <option value="Analog">Analog (kopya)</option>
        </select>
      </div>

      {/* Orijinallıq */}
      <div>
        <h3>
          Orjinal hissədirmi? <span>*</span>
          <span className="tooltip-icon" title="Zavod istehsalımı?">ℹ️</span>
        </h3>
        <select name="isOriginal" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, orjinal ✅</option>
          <option value="false">Xeyr, analog</option>
        </select>
      </div>

      {/* İstehsalçı ölkə */}
      <div>
        <h3>
          İstehsalçı ölkə
          <span className="tooltip-icon" title="Hissə harada istehsal olunub">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="manufacturerCountry" 
          onChange={handleChange}
          placeholder="Almaniya, Çin, Türkiyə..."
        />
      </div>

      {/* Qiymət vahidi */}
      <div>
        <h3>
          Say / Vahid <span>*</span>
          <span className="tooltip-icon" title="Neçə ədəd satılır?">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="quantity" 
          onChange={handleChange}
          placeholder="1"
          min="1"
          required
        />
      </div>

      {/* Zəmanət */}
      <div>
        <h3>
          Zəmanət <span>*</span>
          <span className="tooltip-icon" title="Rəsmi zəmanət varmı?">ℹ️</span>
        </h3>
        <select name="hasWarranty" onChange={handleBooleanChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, zəmanətli ✅</option>
          <option value="false">Xeyr, zəmanətsiz</option>
        </select>
      </div>

      {/* Çatdırılma */}
      <div>
        <h3>
          Çatdırılma
          <span className="tooltip-icon" title="Kuryer xidməti varmı?">ℹ️</span>
        </h3>
        <select name="hasDelivery" onChange={handleBooleanChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli, çatdırılır 🚚</option>
          <option value="false">Xeyr, özünüz götürün</option>
        </select>
      </div>

      {/* OEM nömrəsi */}
      <div>
        <h3>
          OEM / Kataloq nömrəsi
          <span className="tooltip-icon" title="Hissənin zavod nömrəsi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="oemNumber" 
          onChange={handleChange}
          placeholder="A1234567890"
        />
      </div>

      {/* Qeyd */}
      <div style={{ gridColumn: '1 / -1' }}>
        <h3>
          Əlavə qeyd
          <span className="tooltip-icon" title="Əlavə məlumat">ℹ️</span>
        </h3>
        <textarea 
          name="notes" 
          onChange={handleChange}
          placeholder="Hissə haqqında əlavə məlumat..."
          rows="3"
          style={{
            width: '100%',
            padding: '0.875rem 1rem',
            background: 'rgba(255, 255, 255, 0.08)',
            border: '2px solid transparent',
            borderRadius: '0.75rem',
            fontSize: '1rem',
            color: 'var(--text-primary)',
            fontFamily: 'inherit',
            resize: 'vertical'
          }}
        />
      </div>
    </div>
  );
}

export default SparePartsForm;